var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Atom/Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 15C6.21111 15 4.65244 14.4071 3.324 13.2212C1.99556 12.0354 1.23385 10.5542 1.03889 8.77778H2.63333C2.81481 10.1259 3.41448 11.2407 4.43233 12.1222C5.45018 13.0037 6.63941 13.4444 8 13.4444C9.51667 13.4444 10.8034 12.9163 11.8601 11.8601C12.9169 10.8039 13.445 9.51718 13.4444 8C13.4444 6.48333 12.9163 5.19689 11.8601 4.14067C10.8039 3.08444 9.51718 2.55607 8 2.55556C7.10555 2.55556 6.26944 2.76296 5.49167 3.17778C4.71389 3.59259 4.05926 4.16296 3.52778 4.88889H5.66667V6.44444H1V1.77778H2.55556V3.60556C3.21667 2.77593 4.02374 2.13426 4.97678 1.68056C5.92981 1.22685 6.93755 1 8 1C8.97222 1 9.883 1.18485 10.7323 1.55456C11.5817 1.92426 12.3206 2.42307 12.949 3.051C13.5774 3.67996 14.0765 4.41885 14.4462 5.26767C14.8159 6.11648 15.0005 7.02726 15 8C15 8.97222 14.8154 9.883 14.4462 10.7323C14.077 11.5817 13.578 12.3206 12.949 12.949C12.32 13.5774 11.5811 14.0765 10.7323 14.4462C9.88352 14.8159 8.97274 15.0005 8 15ZM10.1778 11.2667L7.22222 8.31111V4.11111H8.77778V7.68889L11.2667 10.1778L10.1778 11.2667Z",
    fill: "#435869"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistory);
export default __webpack_public_path__ + "static/media/icon-history.31ab9c832974b0442636eb39564ac147.svg";
export { ForwardRef as ReactComponent };